import { render, staticRenderFns } from "./AnnuairePage.vue?vue&type=template&id=12a36e8a&"
import script from "./AnnuairePage.vue?vue&type=script&lang=js&"
export * from "./AnnuairePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a36e8a')) {
      api.createRecord('12a36e8a', component.options)
    } else {
      api.reload('12a36e8a', component.options)
    }
    module.hot.accept("./AnnuairePage.vue?vue&type=template&id=12a36e8a&", function () {
      api.rerender('12a36e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/annuaire/AnnuairePage.vue"
export default component.exports